import(/* webpackMode: "eager" */ "/app/src/app/(lyk-appp)/embed/[id]/page.tsx")